import { call, put, takeEvery } from "redux-saga/effects";
import { GetSimulationOTPApi } from "../../utils/api";
import { handleApiResponse } from "../../utils/functions";
import { GetAllSimulationOTPSuccess } from "../Actions/SimulationAction";
import { GET_ALL_SIMULATION_OTP } from "../storeTypes";

function* GetSimulationOTPSaga(action) {
    try {
        const response = yield call(GetSimulationOTPApi, action.payload);
        if (response?.status === 200) {
            yield put(GetAllSimulationOTPSuccess(response?.data?.data));
        }
    } catch (error) {
        handleApiResponse(error?.response.status, error?.response?.data, action?.callBack);
}
}

export function* SimulationSaga() {
    [
        yield takeEvery(GET_ALL_SIMULATION_OTP, GetSimulationOTPSaga),
    ];
}
